import type { Transformer } from '../DataProvider';

import {
  type Branch,
  Gender,
  type RawBranch,
  type RawStoresConfig,
  type StoresConfig,
} from './types';

export const transformBranch = (rawBranch: RawBranch): Branch => ({
  id: rawBranch.id,
  name: rawBranch.name,
  ...(typeof rawBranch.phone === 'string' && { phone: rawBranch.phone }),
  ...(typeof rawBranch.email === 'string' && { email: rawBranch.email }),
  ...(typeof rawBranch.websiteUrl === 'string' && {
    websiteUrl: rawBranch.websiteUrl,
  }),
  ...(typeof rawBranch.imprintUrl === 'string' && {
    imprintUrl: rawBranch.imprintUrl,
  }),
  ...(typeof rawBranch.privacyUrl === 'string' && {
    privacyUrl: rawBranch.privacyUrl,
  }),
  address: {
    ...(rawBranch.address?.city && { city: rawBranch.address.city }),
    ...(rawBranch.address?.additional && {
      additional: rawBranch.address.additional,
    }),
    ...(rawBranch.address?.zip && { zip: rawBranch.address.zip }),
    ...(rawBranch.address?.country?.code && {
      country: { code: rawBranch.address.country.code },
    }),
    ...(rawBranch.address?.street && { street: rawBranch.address.street }),
    ...(rawBranch.address?.latitude && {
      latitude: Number.parseFloat(rawBranch.address.latitude),
    }),
    ...(rawBranch.address?.longitude && {
      longitude: Number.parseFloat(rawBranch.address.longitude),
    }),
  },
  contacts: rawBranch.contacts
    ? rawBranch.contacts.map((rawContact) => ({
        firstName: rawContact.firstName ?? '',
        lastName: rawContact.lastName ?? '',
        gender: rawContact.gender ?? Gender.DIVERS,
        ...(rawContact.emails && {
          emails: rawContact.emails.map((rawEmail) => rawEmail.email),
        }),
        ...(rawContact.phones && {
          phones: rawContact.phones.map((rawPhone) => rawPhone.phone),
        }),
        ...(rawContact.image?.uuid && {
          image: rawContact.image,
        }),
      }))
    : [],
  openingHours: rawBranch.meta?.open ?? {},
  hasOpeningHours: rawBranch.hasOpeningHours,
  productCount: rawBranch.productCount ?? 0,
  reference: rawBranch.reference,
  image: rawBranch.image,
  logo: rawBranch.logo,
  mapMarker: rawBranch.mapMarker,
});

export const transformStores: Transformer<RawStoresConfig, StoresConfig> = (data) => {
  if (data) {
    return data.map((rawBranch) => transformBranch(rawBranch));
  }

  throw new Error('JSON data not available for stores.json');
};
